"use client";

import { useMemo } from "react";
import { useTranslations } from "next-intl";
import { DataField, HStack, Stack, Text } from "@leabankab/component-library";
import { DetailList, OfferHeroCard } from "@/components/ui";
import { useCurrency } from "@/hooks";
import { formatRate } from "@/shared/amount";
import { CreditCardStartInformationContext } from "../types";

const CreditCardStartComponent = ({
	creditLimit,
	interestRate,
	yearFee,
	administrationFee,
}: CreditCardStartInformationContext) => {
	const t = useTranslations("pages.StartInformationPage");
	const { format } = useCurrency();

	const feeRows = useMemo(
		() => [
			{
				label: t("list.yearFee"),
				value: format(yearFee),
			},
			{
				label: t("list.administrationFee"),
				value: format(administrationFee),
			},
		],
		[administrationFee, format, t, yearFee]
	);

	return (
		<Stack gap={2}>
			<OfferHeroCard>
				<Stack className="relative z-1">
					<Text textStyle="heading-xl" color="text.contrast">
						{format(creditLimit)}
					</Text>
				</Stack>

				<HStack justify="between" className="relative z-1">
					<div className="flex flex-col">
						<Text
							textStyle="body-sm"
							fontWeight="regular"
							color="primary.subtle"
							className="uppercase"
						>
							{t("list.interestRate")}
						</Text>
						<Text textStyle="heading-sm" color="text.contrast">
							{formatRate(interestRate)}
						</Text>
					</div>
				</HStack>
			</OfferHeroCard>

			<DetailList>
				{feeRows.map((row, index) => (
					<DataField
						key={row.label}
						label={row.label}
						value={row.value}
						divider={index !== feeRows.length - 1}
					/>
				))}
			</DetailList>
		</Stack>
	);
};

export default CreditCardStartComponent;
